import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, GlobalSignalRListener, BaasicButton, BaasicConfirmModal, BaasicConfirmModalNew, BaasicModal, BaasicDraggableModal, ScrollToTopButton } from 'core/components';
import { PreviewLayout } from 'core/layouts';
import { toDate } from "core/utils";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { DropDownButton, DropDownButtonItem, Button } from "@progress/kendo-react-buttons";
import { FacilityOrderPatientNewFlowUSIntakePreview, FacilityOrderNewFlowStatusBar, FacilityOrderNewFlowUSIntakeFindAndReplaceModal, CreateFacilityOrderTemplateUSIntakeNewFlowModal, FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal, FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal, FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal, FacilityOrderTemplateNewFlowUSIntakePortalNoteModal,FacilityOrderTemplateDoNotSupplyModal, FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModal, FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal, FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal, FacilityOrderPatientNewFlowInsuranceEditModal } from "application/facility-order-new-flow-us-intake/components";
import { FacilityOrderTemplateItemNewFlowCalculationModal, FacilityOrderTemplateNewFlowDeleteModal, FacilityOrderTemplateItemNewFlowDeleteQuestionModal } from "application/facility-order-new-flow/components";
import { FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal, FacilityOrderPatientNewFlowInsuranceNoteModal } from "application/facility-order-new-flow-insurance/components";
import moment from "moment";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FacilityOrderTemplateNewFlowInvoiceNoteModal } from "application/facility-order/components";

function FacilityOrderNewFlowUSIntakePreviewTemplate({ facilityOrderNewFlowUSIntakePreviewViewStore }) {
    const {
        rootStore,
        loaderStore,
        id,
        signalRAction,
        pickTicketHeaderStatus,
        facilityOrder,
        facilityOrderStatus,
        isStatusBarVisible,
        changeStatusBarVisibility,
        orderHistory,
        goToFacilityPreview,
        goToFacilityCalendar,
        downloadFacilityOrder,
        tabItems,
        setStatus,
        selectedStatusAbrv,
        disabled,
        setUSIntakeStatus,
        statusConfirmModal,
        filterByQuestion,
        questionsStore,
        selectedQuestions,
        itemCategoryStore,
        filterByCategory,
        itemCategories,
        goToCreatePatient,
        downloadInventoryReport,
        openFacilityOrderNewFlowUSIntakeFindAndReplaceModal,
        facilityOrderNewFlowUSIntakeFindAndReplaceModal,
        downloadFacilityOrderCsv,
        loadingTemplates,
        isEmpty,
        isReviewed,
        facilityOrderTemplatesGroupByPatient,
        reviewAllDischargeTemplates,
        lookups,
        createFacilityOrderTemplateUSIntakeNewFlowModal,
        facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal,
        facilityOrderTemplateItemNewFlowCalculationModal,
        facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal,
        facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal,
        templateChangeConfirmModal,
        facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal,
        facilityOrderTemplateNewFlowInvoiceNoteModal,
        facilityOrderTemplateNewFlowUSIntakePortalNoteModal,
        facilityOrderTemplateDoNotSupplyModal,
        facilityOrderTemplateNewFlowUSIntakeClinicalInformationModal,
        facilityOrderTemplateNewFlowDeleteModal,
        facilityOrderTemplateItemNewFlowDeleteQuestionModal,
        facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal,
        facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal,
        facilityOrderPatientNewFlowInsuranceEditModal,
        facilityOrderPatientNewFlowInsuranceNoteModal,
        extraSuppliesApprovalRequiredModal,
        disabledSendOrder,
        isInventoryStepAllowed,
        openInventoryRequestWindow,
        isInventoryRequestSent,
        hideInventoryEmailButton,
        openInventoryRequestWindowThroughActionsMenu,
        hasValidEmailType
    } = facilityOrderNewFlowUSIntakePreviewViewStore;

    const handleDropDownItemsOnClick = (e) => {
        if (e.item.text === "New Patient") {
            goToCreatePatient();
        }
        if (e.item.text === "Find and Replace") {
            openFacilityOrderNewFlowUSIntakeFindAndReplaceModal();
        }
        if (e.item.text === "Inventory Report") {
            downloadInventoryReport();
        }
        if (e.item.text === "Export FO CSV") {
            downloadFacilityOrderCsv();
        }
        if(e.item.text === "Inventory Request Email"){
            openInventoryRequestWindowThroughActionsMenu();
        }
    }

    return (
        <PreviewLayout className="container container--new-flow" store={facilityOrderNewFlowUSIntakePreviewViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading}>
            <GlobalSignalRListener groupId={id} rootStore={rootStore} action={signalRAction} />
            {!loaderStore.loading &&
                <React.Fragment>
                    {(pickTicketHeaderStatus == "in-progress" || pickTicketHeaderStatus == "completed" || facilityOrder.sendOrder) &&
                        <div className='purches-notification'>
                            <div className='message__bar purches-notification-row'>
                                <span>{pickTicketHeaderStatus === "in-progress" ? "Purchasing is in progress. Don't make changes to the facility order." : pickTicketHeaderStatus === "completed" ? "Purchasing is complete. Don't make changes to the facility order." : "Billing is in Progress, any changes made must be reported to the biller."}</span>
                            </div>
                        </div>
                    }
                    <FacilityOrderNewFlowStatusBar facilityOrder={facilityOrder} title={facilityOrder && `${facilityOrder.facility.name} - DOS ${toDate(facilityOrder.dateOfService)}`} isOpen={isStatusBarVisible} changeStatusBarVisibility={() => changeStatusBarVisibility()} isInventoryStepAllowed={isInventoryStepAllowed}>
                        <div className="content__header__actions card--tertiary__data__item">
                            <ReactTooltip positionStrategy="fixed" id="historyTooltip" place="bottom" />
                            <Button className="btn btn--base btn--light u-mar--right--tny" icon="u-icon u-icon--med-lrg u-icon--us-history" onClick={() => orderHistory()} data-tooltip-content="Facility Order History" data-tooltip-id="historyTooltip" />

                            <ReactTooltip positionStrategy="fixed" id="facilityPreviewTooltip" place="bottom" />
                            <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Facility Preview" data-tooltip-id="facilityPreviewTooltip" onClick={() => goToFacilityPreview()}><i className="u-icon u-icon--sml u-icon--preview--dark"></i></a>

                            <ReactTooltip positionStrategy="fixed" id="orderingTooltip" place="bottom" />
                            <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Ordering Calendar" data-tooltip-id="orderingTooltip" onClick={() => goToFacilityCalendar()}><i className="u-icon u-icon--sml u-icon--schedules"></i></a>

                            <ReactTooltip positionStrategy="fixed" id="reportTooltip" place="bottom" />
                            <a className="btn btn--base btn--light" target='_blank' data-tooltip-content="FO Report Download" data-tooltip-id="reportTooltip" onClick={() => downloadFacilityOrder()}><i className="u-icon u-icon--sml u-icon--download--brand"></i></a>
                        </div>
                    </FacilityOrderNewFlowStatusBar>
                    <div className="u-flex--space-between">
                        <div className="tabs__wrapper">
                            <div className="tabs tabs--fullwidth">
                                {tabItems.map(item =>
                                    <BaasicButton key={item.abrv}
                                        className={"tabs__item " + (item.abrv == selectedStatusAbrv ? 'active' : '')}
                                        label={item.name}
                                        onClick={() => item.abrv != selectedStatusAbrv ? setStatus(item.abrv) : {}}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="u-flex--default u-mar--left--auto">
                            {!(facilityOrderStatus && facilityOrderStatus.startedOn) &&
                                <BaasicButton className="btn btn--base btn--primary u-mar--right--sml" disabled={disabledSendOrder} label="Start" onClick={() => setUSIntakeStatus()} />
                            }
                            {selectedStatusAbrv !== "discharge" &&
                                <div className="multiselect__group is-questions u-mar--right--sml">
                                    <MultiSelect
                                        data={questionsStore.originalItems}
                                        textField="name"
                                        dataItemKey="id"
                                        value={selectedQuestions}
                                        filterable={false}
                                        placeholder="Please select"
                                        disabled={loadingTemplates}
                                        onChange={(e) => filterByQuestion(e)}
                                        tags={
                                            selectedQuestions.length > 0
                                                ? [
                                                    {
                                                        text: selectedQuestions.length == 1 ? selectedQuestions[0].name : `Multiple`,
                                                        data: selectedQuestions,
                                                    },
                                                ] : []
                                        }
                                    />
                                </div>
                            }
                            <div className="multiselect__group is-category u-mar--right--sml">
                                <MultiSelect
                                    data={itemCategoryStore.originalItems}
                                    textField="name"
                                    dataItemKey="id"
                                    value={itemCategories}
                                    filterable={false}
                                    placeholder="Please select"
                                    disabled={loadingTemplates}
                                    onChange={(e) => filterByCategory(e)}
                                    tags={
                                        itemCategories.length > 0
                                            ? [
                                                {
                                                    text: itemCategories.length == 1 ? itemCategories[0].name : `Multiple`,
                                                    data: itemCategories,
                                                },
                                            ] : []
                                    }
                                />
                            </div>
                            {selectedStatusAbrv === "discharge" &&
                                <BaasicButton className="btn btn--base btn--sml btn--primary u-mar--right--sml" icon="u-icon u-icon--xmed u-icon--checks" label="Review All" onClick={() => { reviewAllDischargeTemplates() }} disabled={disabled || disabledSendOrder || !(facilityOrderTemplatesGroupByPatient && facilityOrderTemplatesGroupByPatient.length > 0 && facilityOrderTemplatesGroupByPatient.some(x => x.facilityOrderTemplates && !x.facilityOrderTemplates.some(j => j.isReviewed)))} />
                            }
                            <div className='u-mar--right--sml'>
                                <DropDownButton
                                    fillMode={"solid"}
                                    themeColor={"primary"}
                                    text="Actions"
                                    onItemClick={(e) => handleDropDownItemsOnClick(e)}
                                    buttonClass="btn btn--base btn--sml btn--ghost"
                                    disabled={disabled}
                                    popupSettings={{
                                        animate: false,
                                        anchorAlign: { horizontal: "right", vertical: "bottom" },
                                        popupAlign: { horizontal: "right", vertical: "top" },
                                        popupClass: 'is-clean'
                                    }}
                                >
                                    {selectedStatusAbrv !== "discharge" && !disabledSendOrder && <DropDownButtonItem text="New Patient"iconClass="u-icon u-icon--sml u-icon--add-lined u-mar--right--tny" />}
                                    <DropDownButtonItem disabled={!(facilityOrderStatus && facilityOrderStatus.startedOn)} text="Inventory Report" />
                                    <DropDownButtonItem text="Inventory Request Email"/>
                                    {!disabledSendOrder && <DropDownButtonItem text="Find and Replace" />}
                                    <DropDownButtonItem text="Export FO CSV" />
                                </DropDownButton>
                            </div>
                        </div>
                    </div>
                    {loadingTemplates ?
                        <div>Loading...</div>
                        :
                        <React.Fragment>
                            {selectedStatusAbrv === "in-progress" && facilityOrderStatus && facilityOrderStatus.completedOn &&
                                <div className='u-mar--bottom--tny'>
                                    <div className="u-mar--bottom--sml">US Intake review has been completed on {moment(facilityOrderStatus.completedOn).format("MM/DD/YYYY, hh:mm A")}</div>
                                    <BaasicButton className="btn btn--base btn--ghost u-mar--bottom--sml" label="Download Inventory Report" onClick={() => downloadInventoryReport()} />
                                </div>
                            }
                            {selectedStatusAbrv === "discharge" && !(facilityOrderStatus && facilityOrderStatus.completedOn) && isReviewed && (isInventoryRequestSent || hideInventoryEmailButton) &&
                                <div className="empty-state--facility-orders-discharges">
                                    <p className="empty-state--facility-orders-discharges--description">You have no orders in progress!</p>
                                    <BaasicButton className="btn btn--base btn--primary" disabled={disabledSendOrder} label="US Intake is Complete" onClick={() => setUSIntakeStatus(true)} />
                                </div>
                            }

                            {selectedStatusAbrv === "discharge" && !(facilityOrderStatus && facilityOrderStatus.completedOn) && isReviewed && !isInventoryRequestSent && !hideInventoryEmailButton && hasValidEmailType &&
                                (<div className="empty-state--facility-orders-discharges">
                                    <p className="empty-state--facility-orders-discharges--description">You have no orders in progress!</p>
                                    <BaasicButton className="btn btn--base btn--primary" disabled={disabledSendOrder} icon="u-icon u-icon--med u-icon--mail-send--new--invert" label="Inventory Request" onClick={() => openInventoryRequestWindow()} />
                                </div>)
                            }
                            
                            {(facilityOrderTemplatesGroupByPatient && facilityOrderTemplatesGroupByPatient.length > 0) ?
                                facilityOrderTemplatesGroupByPatient.map(pt => {
                                    return (
                                        <FacilityOrderPatientNewFlowUSIntakePreview
                                            key={pt.id}
                                            facilityOrder={facilityOrder}
                                            facilityOrderTemplatesGroupByPatient={facilityOrderTemplatesGroupByPatient}
                                            pageViewStore={facilityOrderNewFlowUSIntakePreviewViewStore}
                                            facilityOrderPatient={pt.facilityOrderPatient}
                                            facilityOrderTemplates={pt.facilityOrderTemplates}
                                            selectedStatusAbrv={selectedStatusAbrv}
                                            disabled={disabled}
                                            disabledSendOrder={disabledSendOrder}
                                            lookups={lookups}
                                            facilityOrderStatus={facilityOrderStatus}
                                        />
                                    );
                                })
                                :
                                isEmpty &&
                                (
                                    <React.Fragment>                                    
                                        {isReviewed && !isInventoryRequestSent && !hideInventoryEmailButton && hasValidEmailType &&
                                        (
                                            <div className="empty-state--facility-orders">
                                                <div className="empty-state--facility-orders--table"></div>
                                                <p className="empty-state--facility-orders--description">You have no orders in progress!</p>
                                                <BaasicButton className="btn btn--base btn--primary" disabled={disabledSendOrder} icon="u-icon u-icon--med u-icon--mail-send--new--invert" label="Inventory Request" onClick={() => openInventoryRequestWindow()} />
                                            </div>)
                                        }
                                        {isReviewed &&  (isInventoryRequestSent || hideInventoryEmailButton) && (
                                                    <div className="empty-state--facility-orders">
                                                        <div className="empty-state--facility-orders--table"></div>
                                                        <p className="empty-state--facility-orders--description">You have no orders in progress!</p>
                                                        <BaasicButton
                                                            className="btn btn--base btn--primary"
                                                            label="US Intake is Complete"
                                                            onClick={() => setUSIntakeStatus(true)}
                                                        />
                                                    </div>
                                        )}
                                        {isReviewed === false && !isInventoryRequestSent && (
                                            <div className="u-mar--bottom--sml">
                                                All In Progress templates have been reviewed. Please review the discharged templates to complete US Intake.
                                            </div>
                                        )}
                                    </React.Fragment>
                                )
                            }
                        </React.Fragment>
                    }
                </React.Fragment>
            }
            <BaasicConfirmModal modalParams={statusConfirmModal} />
            <BaasicModal modalParams={facilityOrderNewFlowUSIntakeFindAndReplaceModal} className="modal__content modal--xlrg">
                <FacilityOrderNewFlowUSIntakeFindAndReplaceModal />
            </BaasicModal>
            <BaasicModal modalParams={createFacilityOrderTemplateUSIntakeNewFlowModal} className="modal__content modal--xxlrg">
                <CreateFacilityOrderTemplateUSIntakeNewFlowModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderTemplateNewFlowUSIntakeTemplateActivationModal} className="modal__content modal--lrg">
                <FacilityOrderTemplateNewFlowUSIntakeTemplateActivationModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateItemNewFlowCalculationModal}>
                <FacilityOrderTemplateItemNewFlowCalculationModal />
            </BaasicDraggableModal>
            <BaasicDraggableModal modalParams={facilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal />
            </BaasicDraggableModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal />
            </BaasicDraggableModal>
            <BaasicConfirmModal modalParams={templateChangeConfirmModal} />
            <BaasicModal modalParams={facilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal} className="modal__content modal--xxlrg">
                <FacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderTemplateNewFlowInvoiceNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowInvoiceNoteModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateNewFlowUSIntakePortalNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowUSIntakePortalNoteModal />
            </BaasicDraggableModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateDoNotSupplyModal} className="modal__content modal--med">
                <FacilityOrderTemplateDoNotSupplyModal />
            </BaasicDraggableModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateNewFlowUSIntakeClinicalInformationModal} className="modal__content modal--lrg">
                <FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModal />
            </BaasicDraggableModal>
            <BaasicModal modalParams={facilityOrderTemplateNewFlowDeleteModal} className="modal__content modal--lrg">
                <FacilityOrderTemplateNewFlowDeleteModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderTemplateItemNewFlowDeleteQuestionModal} className="modal__content modal--med">
                <FacilityOrderTemplateItemNewFlowDeleteQuestionModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={facilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal />
            </BaasicDraggableModal>
            <BaasicDraggableModal modalParams={facilityOrderPatientNewFlowUSIntakeInsuranceInfoModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal />
            </BaasicDraggableModal>
            <BaasicModal modalParams={facilityOrderPatientNewFlowInsuranceEditModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowInsuranceEditModal />
            </BaasicModal>
            <BaasicModal modalParams={facilityOrderPatientNewFlowInsuranceNoteModal} className="modal__content modal--med">
                <FacilityOrderPatientNewFlowInsuranceNoteModal />
            </BaasicModal>
            <BaasicConfirmModalNew modalParams={extraSuppliesApprovalRequiredModal} />
            <ScrollToTopButton />
        </PreviewLayout>
    )
}

FacilityOrderNewFlowUSIntakePreviewTemplate.propTypes = {
    facilityOrderNewFlowUSIntakePreviewViewStore: PropTypes.object.isRequired
};

export default defaultTemplate(FacilityOrderNewFlowUSIntakePreviewTemplate);